


























































import { Component, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  BibliographySearchResultsAuthorityTableItem,
  BookbindingCollectionsTable
} from '@/components/organisms/BookbindingCollectionsTable'
import { BookbindingCollectionsFilteringCondition } from '@/components/organisms/BookbindingCollectionsFilteringCondition'
import { NAV_LOADING_END, NAV_LOADING_START } from '@/config/event'
import { Alert, AlertMessage, collectionApi, ErrorMessage } from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import {
  BookbindingCollectionsFilteringConditionItem,
  defaultBookbindingCollectionsFilteringConditionItem
} from '@/components/organisms/BookbindingCollectionsFilteringCondition/BookbindingCollectionsFilteringCondition.vue'

interface ModalBookbindingCollectionsInterface {
  bibliographySetId: number
  onClickOk: (collectionIds: number[]) => void
}

@Component({
  components: {
    BookbindingCollectionsFilteringCondition,
    BookbindingCollectionsTable,
    ModalFooter
  }
})
export default class ModalBookbindingCollections extends ComponentVue {
  @Ref()
  bookbindingCollectionsFilteringCondition!: BookbindingCollectionsFilteringCondition

  dialog: boolean = false

  tableBodyHeight: number = 0

  bibliographySetId: number = 0

  filteringConditionItem: BookbindingCollectionsFilteringConditionItem = defaultBookbindingCollectionsFilteringConditionItem()

  tableItems: BibliographySearchResultsAuthorityTableItem[] = []

  okCallback?: (collectionIds: number[]) => void

  open(params: ModalBookbindingCollectionsInterface): void {
    this.dialog = true
    window.addEventListener('resize', this.calculateTableHeight)
    this.bibliographySetId = params.bibliographySetId
    this.okCallback = params.onClickOk
    this.getBookbindingTargetMagazineCollections()

    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(
        this.bookbindingCollectionsFilteringCondition.focusVolumeFromTextField
      )
    })
  }

  close(): void {
    this.dialog = false
    this.bibliographySetId = 0
    this.filteringConditionItem = defaultBookbindingCollectionsFilteringConditionItem()
    this.tableItems = []
    this.okCallback = undefined
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      const modalElements: HTMLCollection | null = document.getElementsByClassName(
        'v-dialog--active'
      ) as HTMLCollectionOf<HTMLElement>

      this.tableBodyHeight =
        window.innerHeight -
        (modalElements[modalElements.length - 1]?.clientHeight + 48)
    })
  }

  onClickClear(): void {
    this.filteringConditionItem = defaultBookbindingCollectionsFilteringConditionItem()
    this.bookbindingCollectionsFilteringCondition.focusVolumeFromTextField()
  }

  onClickOk(): void {
    if (this.okCallback) {
      this.okCallback(
        this.tableItems
          .filter(item => item.isSelected)
          .map(item => item.collectionId)
      )
    }

    this.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bookbinding-collections')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async getBookbindingTargetMagazineCollections(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.tableItems = (
        await collectionApi.getBookbindingTargetMagazineCollections({
          bibliographySetId: this.bibliographySetId,
          volumeFrom: this.filteringConditionItem.volumeFrom.input,
          volumeTo: this.filteringConditionItem.volumeTo.input,
          volumeNumberFrom: this.filteringConditionItem.volumeNumberFrom.input,
          volumeNumberTo: this.filteringConditionItem.volumeNumberTo.input,
          volumeTotalFrom: this.filteringConditionItem.volumeTotalFrom.input,
          volumeTotalTo: this.filteringConditionItem.volumeTotalTo.input,
          dateLabelFrom: this.filteringConditionItem.dateLabelFrom.input,
          dateLabelTo: this.filteringConditionItem.dateLabelTo.input,
          holdingBranchCode: this.filteringConditionItem.holdingBranchCode.input
        })
      ).map(value => {
        return {
          isSelected: false,
          ...value
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.filteringConditionItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
